export default __webpack_public_path__ + "static/media/Screenshot_A5.ba49337d.png";